var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.container }, [
    _vm.image
      ? _c("img", {
          class: _vm.$style.pictureImage,
          attrs: { alt: "picture", src: _vm.image },
        })
      : _c("div", { class: _vm.$style.noPicture }, [
          _c("div", {
            staticClass: "fa fa-building",
            class: _vm.$style.noPictureIcon,
            attrs: { "aria-hidden": "true" },
          }),
          _c("div", { class: _vm.$style.noPictureLabel }, [
            _vm._v("Picture of your Property"),
          ]),
        ]),
    _c("div", { class: _vm.$style.logoContainer }, [
      _vm.logo
        ? _c("img", {
            class: _vm.$style.logoImage,
            attrs: { alt: "logo", src: "/images/logos/" + _vm.logo },
          })
        : _c("div", { class: _vm.$style.noLogo }, [
            _c("div", {
              staticClass: "fa fa-image",
              class: _vm.$style.noLogoIcon,
              attrs: { "aria-hidden": "true" },
            }),
            _c("div", { class: _vm.$style.noLogoLabel }, [_vm._v("Your Logo")]),
          ]),
    ]),
    _c(
      "button",
      {
        staticClass:
          "rbButton expandButtonToShowText accountProfileUploadImageButton",
        class: _vm.$style.uploadLogoButton,
        on: { click: _vm.editLogo },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("add_a_photo")]),
        _vm._v(" "),
        _c("span", { class: _vm.$style.uploadButtonLabel }, [_vm._v("Upload")]),
      ]
    ),
    _vm.isAdmin
      ? _c(
          "button",
          {
            staticClass:
              "rbButton expandButtonToShowText accountProfileUploadImageButton",
            class: _vm.$style.uploadPictureButton,
            on: { click: _vm.editImage },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("add_a_photo")]),
            _vm._v(" "),
            _c("span", { class: _vm.$style.uploadButtonLabel }, [
              _vm._v("Upload"),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }